import actionTypes from '../constants/action-types';

const getTldCollection = () => ({
  type: actionTypes.GET_TLD_COLLECTION,
});

export default getTldCollection;
